<template>
    <dashboard-layout title="비대면 면접" topBtn fullHeight>
        <template slot="topBtn">
            <interview-view mode="list">
                <template #create="{ loading }">
                    <interview-form @input="updateItem">
                        <template #activator="{ attrs, on }">
                            <v-btn color="secondary" v-bind="{ ...attrs, loading }" v-on="on">
                                <span> 비대면 면접 생성 </span>
                            </v-btn>
                        </template>
                    </interview-form>
                </template>
            </interview-view>
        </template>
        <template slot="contents">
            <template v-if="items.length">
                <div class="v-cards">
                    <template v-for="(item, index) in items">
                        <interview-list-item
                            v-model="items[index]"
                            v-bind="{
                                loading,
                            }"
                            v-on="{
                                update,
                                remove,
                                input: updateItem,
                            }"
                            :key="item._id"
                        />
                    </template>
                </div>
                <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
            </template>
            <template v-else>
                <v-layout column justify-center align-center class="w-100 h-100 grey-f7 rounded-lg pa-20">
                    <p class="page-text--lg line-height-15 text-center mb-12 mb-lg-32">
                        안녕하세요, 담당자님. <br />
                        생성된 면접이 없습니다.
                    </p>
                    <interview-form @input="updateItem">
                        <template #activator="{ attrs, on }">
                            <v-btn v-bind="attrs" v-on="on" text height="auto" color="transparent" class="v-btn--column">
                                <i class="icon icon-plus-lg" />
                                <span class="mt-6 mt-lg-14 grey-9--text">면접 생성하기</span>
                            </v-btn>
                        </template>
                    </interview-form>
                </v-layout>
            </template>
        </template>
    </dashboard-layout>
</template>

<script>
import api from "@/api";

import DashboardLayout from "@/components/dashboard/dashboard-layout.vue";
import InterviewForm from "@/components/dashboard/company/interview/form/interview-form.vue";
import InterviewView from "@/components/dashboard/common/interview/view/interview-view.vue";
import InterviewListItem from "@/components/dashboard/company/interview/list/interview-list-item.vue";

export default {
    components: {
        DashboardLayout,
        InterviewForm,
        InterviewView,
        InterviewListItem,
    },
    data: () => ({
        loading: false,
        interviews: [],

        limit: 10,
        summary: { totalCount: 0 },

        showsSearch: true,
    }),
    computed: {
        items() {
            return this.interviews.map((item, index) => ({ ...item, index: this.summary.totalCount - (this.page - 1) * this.limit - index }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;
            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        init() {
            this.search();
        },
        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit, params } = this;
                var { summary, interviews } = await api.v1.company.interviews.gets({
                    headers: { skip, limit },
                    params,
                });

                this.interviews = interviews;
                this.summary = summary;
            } finally {
                if (this.loading) this.loading = false;
            }
        },
        async update(item) {
            if (this.loading) return;
            else this.loading = true;
            try {
                const { meeting } = await api.v1.company.interviews.put(item);
                this.loading = false;
                this.updateItem(meeting);
            } finally {
                if (this.loading) this.loading = false;
            }
        },
        async remove(item) {
            if (this.loading) return;
            else this.loading = true;
            try {
                await api.v1.company.interviews.delete(item);

                this.loading = false;
                this.search();
            } finally {
                if (this.loading) this.loading = false;
            }
        },
        updateItem(item) {
            const index = this.interviews.findIndex(({ _id }) => _id == item._id);
            if (0 <= index) this.interviews.splice(index, 1, item);
            else {
                this.interviews = [item, ...this.interviews];
                this.summary.totalCount += 1;
            }
            this.search();
        },
    },
};
</script>

<style></style>
